export const AUTH_TOKEN_STORAGE_KEY = '@token';
export const GRAPH_TOKEN_STORAGE_KEY = '@graphToken';
